<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/sp1.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/sp2.png" class="steps step2" v-if="status==2">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清提报详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>交互记录</h1>
                                </div>
                                <div class="h-pieceCon2 ljjtablehuanhang" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="execution"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                width="120"
                                                prop="lianqun"
                                                label="链群">
                                            <template scope="scope">
                                                {{scope.row.lianqun | dictname('gh_lianqun')}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                width="160"
                                                prop="cdate"
                                                label="拜访时间"
                                                >
                                        </el-table-column>
                                        <el-table-column
                                                prop="euName"
                                                label="用户/客户名称"
												min-width="160"
                                                >
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.euName}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planRemark"
                                                label="拜访目标"
												min-width="200"
                                                >
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.planRemark}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="result"
                                                label="实际工作效果"
												min-width="250"
                                                >
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.result}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="contact"
                                                label="联系人"
                                                width="80"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactDept"
                                                label="科室"
                                                width="80"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactPhone"
                                                label="联系方式"
                                                width="120"
                                        >
											<template slot-scope="scope">
												<div style="text-align: left;">
													{{scope.row.contactPhone}}
												</div>
											</template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>明日计划</h1>
                                </div>
                                <div class="h-pieceCon2 ljjtablehuanhang" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="plan"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="euName"
                                                label="用户/客户名称"
												min-width="150"
                                                >
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.euName}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planTimeStart"
                                                label="开始日期"
												width="160"
                                               >
                                            <template scope="scope">
                                                {{scope.row.planTimeStart.substr(0,10)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planTimeEnd"
                                                label="结束日期"
												width="160"
                                                >
                                            <template scope="scope">
                                                {{scope.row.planTimeEnd.substr(0,10)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="planRemark"
                                                label="拜访目标"
												min-width="250"
                                                >
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.planRemark}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="contact"
                                                width="80"
                                                label="联系人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="contactPhone"
                                                width="120"
                                                label="联系电话">
													<template slot-scope="scope">
														<div style="text-align: left;">
															{{scope.row.contactPhone}}
														</div>
													</template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>资源需求</h1>
                                </div>
                                <div class="h-pieceCon2 ljjtablehuanhang" style="padding:0">
                                    <el-table
                                            ref="multipleTable"
                                            :data="source"
                                            stripe
											border
                                            style="width: 100%"
                                    >
                                        <el-table-column
                                                type="index"
                                                width="40"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                width="120"
                                                prop="lianqun"
                                                label="链群">
                                            <template scope="scope">
                                                {{scope.row.lianqun | dictname('gh_lianqun')}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="content"
												min-width="250"
                                                label="内容详细描述">
												<template slot-scope="scope">
													<div style="text-align: left;">
														{{scope.row.content}}
													</div>
												</template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="nameList"
												width="110"
                                                label="指定答复人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="endDate"
                                                label="指定答复日期"
												width="160"
                                                >
                                        </el-table-column>

                                    </el-table>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>其他问题</h1>
                                </div>
                                <div class="h-pieceCon2 textresize" style="padding:0">
                                    <div style="padding:0 10px;color:#686868;font-size:16px;">
                                        {{summary.notes}}
                                    </div>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin:50px 0;"></div>
                                <div v-if="summary.adjScore" class="pinfen">
                                    该日请的评分为：
                                    <span :class="{'active':summary.adjScore == 'D'}">{{summary.adjScore}}级</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		<div class="h-piece Yijian" v-if="zstype" style="margin: 0.22rem 0.38rem 0 0.32rem;">
			<div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
			    <h1>审批意见</h1>
			</div>
		    <div class="h-table h-mrt30 bbbb" style="margin-top: 0.1rem;">
		        <div class="h-pieceTitle2 hang" style="margin-bottom: 0;">
		            <el-form :model="formLabelAlign" label-position="right" :inline="true"
		                     class="demo-ruleForm h-formbLine inputO">
		                <el-form-item label="日请评分" class="h-elformWrap-2 " :required="flaag"
		                              style="margin:0 0 0.1rem 0.2rem">
		                    <el-input v-model="summary.sysScore" placeholder="请输入"
		                              class="zidaoO"></el-input>
		                </el-form-item>
		                <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
		                              style="margin:0.2rem 0 0.1rem 0.2rem">
		                    <el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"
		                              class="zidaoO"></el-input>
		                </el-form-item>
		            </el-form>
		        </div>
		    </div>
		</div>
        <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
            <div class="apprButton">
                <el-row>
                    <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default"
                               @click="cancelRq">返回
                    </el-button>
                    <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="pass">
                        提交
                    </el-button>
                </el-row>
            </div>
            <el-button v-if="!zstype" @click="cancelRq" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default">
                返回
            </el-button>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';

    export default {
        data() {
            return {
                showOrhide:false,
				status:1,
				checked:true,
				toshow:"persentation2",
                textarea: '',
                q: {},
                execution: [],
                source: [],
                product: [],
                summary: {},
                formLabelAlign: {},
                zstype: false,
                flaag: true,
                plan: [],
            }
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/riqinggly' && from.path == '/presentation2'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
						setTimeout(function(){
							document.documentElement.scrollTop = 7600;
						},300)
				    }
				})
			},
            //查询当天所有跑动记录/转化需求/转化产品记录
            query() {
                //查看详情
                if (this.$route.query.rqId) {
                    this.q.summaryId = this.$route.query.rqId;
                }
                if (this.$route.query.ywid) {
                    this.q.summaryId = this.$route.query.ywid;
                }
                if (this.$route.query.taskstatus == 0) {
                    this.zstype = true;
                }
                ss.UserCare.queryExecution(this.q).then(rd => {
                    console.log(rd.todayMap, "下面表格");
                    this.execution = rd.todayMap.execution;
                    this.source = rd.todayMap.source;
                    this.product = rd.todayMap.product;
                    this.summary = rd.todayMap.summary;
                    this.plan = rd.todayMap.plan;
                })
            },
            //用户审核
            usercheck(x) {
                this.formLabelAlign.id = this.$route.query.ywid;
                this.formLabelAlign.taskid = this.$route.query.taskid;
                this.formLabelAlign.status = x;
                console.log(this.formLabelAlign, "审核流程结果");
                ss.UserCare.checkSummary(this.formLabelAlign).then(rd => {
                    console.log('审核流程结果', rd)
                    this.$msg.alerts("提交成功！", () => {
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                    })
                });
            },
            //通过按钮
            pass() {
                if (!this.summary.sysScore) {
                    this.$msg.msge("请填写评分");
                } else {
                    //用户最终的分数存在sysReason中
                    if(/[^\d]/.test(this.summary.sysScore)){
                    this.$msg.msge("请填写评分（数字）");
                    }else{
                        this.formLabelAlign.sysReason = this.summary.sysScore;
                        //填写的分数理由存在adjReason中
                        this.formLabelAlign.adjReason = this.formLabelAlign.checkMsg;
                        this.usercheck(2);
                    }
                }

            },
            //驳回按钮
            refuse() {
                console.log(this.formLabelAlign.checkMsg, "sss");
                if (!this.formLabelAlign.checkMsg) {
                    this.$msg.msge("请填写审批意见");
                }
                {
                    this.formLabelAlign.adjReason = this.formLabelAlign.checkMsg;
                    this.usercheck(3)
                }
            },
            //取消按钮
            cancelRq() {
                this.$router.back();
            },
            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
						this.status = 2;
						document.documentElement.scrollTop = 7600;
				}else if(this.status ==2){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			}
        },
        mounted() {
            this.query();
        },
		created() {
			this.showzhezhao()
		}

    }
</script>
<style>
    .textresize .el-textarea .el-textarea__inner {
        resize: none;
        height: 150px;
    }

    .active {
        color: red;
    }

    .Yijian .h-formbLine .el-form-item__label {
        width: 19%;
    }
	.ljjtablehuanhang .el-table td .cell{
		white-space: normal;
	}
</style>
<style scoped>


    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    .pinfen {
        color: #656565;
        font-size: 16px;
        margin-left: 20px;
        padding: 0 0 30px 0;
    }

    /* .pinfen .pinfenss{
        color:#087ae7;
        font-size:30px;
        font-weight:bold;

    }
    .pinfen .pinfenss.active{
        color: #ff2424;
    } */
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 1.75rem;
			left: 3rem;
			width:15.7rem;
			height: 4.5rem;
		}
		.step2{
			top: 7.05rem;
			right: 4.35rem;
			width: 4rem;
			height: 0.95rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
